<template>
  <div class="card shadow-sm table-card mb-4">
    <div class="form-card-header">
      <div class="section-number"><i class="fe fe-bar-chart-2" style="font-size: 12px;"></i></div>
      <div class="flex-grow-1">
        <h6 class="mb-0 font-weight-bold text-white">Enrolment by programme</h6>
        <small style="color: rgba(255,255,255,.75);">Everyone on file, principals and dependants; new = enrolled in the period</small>
      </div>
      <PeriodPicker v-model="period" @change="load" default-preset="12m" class="picker-light" />
    </div>
    <div class="card-body">
      <div v-if="loading && !data" class="empty-state"><i class="mdi mdi-loading mdi-spin"></i>Loading…</div>
      <div v-else-if="data && !data.rows.length" class="empty-state">No enrollees yet.</div>
      <div v-else-if="data" class="row">
        <div class="col-lg-7">
          <apexchart type="bar" :height="Math.max(220, data.rows.length * 38)" :options="options" :series="series" :key="chartKey" />
        </div>
        <div class="col-lg-5">
          <div class="table-responsive">
            <table class="table table-sm mb-0">
              <thead class="table-head"><tr><th class="table-th">Programme</th><th class="table-th text-right">Total</th><th class="table-th text-right">Share</th><th class="table-th text-right">New</th><th class="table-th text-right">Expired</th></tr></thead>
              <tbody>
                <tr class="table-row" v-for="r in data.rows" :key="r.sector">
                  <td>{{ r.sector }}</td>
                  <td class="text-right"><b>{{ r.total.toLocaleString() }}</b><div class="small text-muted">{{ r.principals.toLocaleString() }} + {{ r.dependants.toLocaleString() }}</div></td>
                  <td class="text-right">{{ r.share_pct }}%</td>
                  <td class="text-right">{{ (r.new_principals + r.new_dependants).toLocaleString() }}</td>
                  <td class="text-right">{{ r.expired_principals.toLocaleString() }}</td>
                </tr>
                <tr class="table-row font-weight-bold" style="background: #f8fafc;"><td>Total</td><td class="text-right">{{ data.totals.total.toLocaleString() }}</td><td></td><td></td><td></td></tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PeriodPicker from "./PeriodPicker.vue";

/** Enrolment distribution by programme (GET analytics/enrollment/sectors). */
export default {
  name: "SectorDistribution",
  components: { PeriodPicker },
  data() {
    return { period: { from: "", to: "" }, data: null, loading: false, chartKey: 0 };
  },
  computed: {
    series() {
      return [
        { name: "Principals", data: this.data.rows.map((r) => r.principals) },
        { name: "Dependants", data: this.data.rows.map((r) => r.dependants) },
      ];
    },
    options() {
      return {
        chart: { stacked: true, toolbar: { show: true } },
        colors: ["#2563eb", "#93c5fd"],
        plotOptions: { bar: { horizontal: true, barHeight: "65%", borderRadius: 3 } },
        xaxis: { categories: this.data.rows.map((r) => r.sector), labels: { formatter: (v) => Math.round(v).toLocaleString() } },
        dataLabels: { enabled: true },
        legend: { position: "top" },
        tooltip: { shared: true, intersect: false, y: { formatter: (v) => (v || 0).toLocaleString() } },
      };
    },
  },
  mounted() {
    if (this.period.from) this.load();
  },
  methods: {
    load() {
      this.loading = true;
      this.$batchGet("/api/v1/auth/analytics/enrollment/sectors", { params: { from: this.period.from, to: this.period.to } })
        .then((res) => { this.data = res.data.data; this.chartKey++; })
        .catch(() => {})
        .finally(() => { this.loading = false; });
    },
  },
};
</script>

<style scoped>
@import "../../reports/reports.css";
.picker-light >>> .form-control { background: rgba(255,255,255,.95); }
</style>
